import { jsx as _jsx } from "react/jsx-runtime";
import { useBillingInformation } from "./Shared/hooks/useBillingInformation/useBillingInformation";
import { ConfirmationDialog } from "../../Shared/components/ConfirmationDialog";
const RemoveCardModal = ({ open, onClose, selectedCard }) => {
    const { removePaymentMethod } = useBillingInformation();
    const confirmRemovePaymentMethod = () => {
        removePaymentMethod(selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.id);
        onClose();
    };
    return (_jsx(ConfirmationDialog, { isOpen: open, dialogTitle: "Are you sure you'd like to remove this card?", cancelButtonText: "Cancel", confirmButtonText: "Confirm", onCancelButtonClick: () => onClose(), onConfirmButtonClick: confirmRemovePaymentMethod }));
};
export default RemoveCardModal;
